const state = {
  currentProjectNavigation:'',
  currentClusterNavigation:'',
  nameCurrProjectNavigation:'',
  nameCurrClusterNavigation:'',
  multiSelectedNavigation:false,
  singleSelectedNavigation: false,
  selectedNavigation:false,
  currentProjectListNavigation:[],
  loadingClustProyNavigation:false,
  allowEditNavigation:false,
  allowEditClusterNavigation:false,
	clusterSelectedObjNavigation:{},
	selectedClusterRecordData:[], // a state to keep track of the selected cluster record data on a table
	selectedProjectRecordData:[], // a state to keep track of the selected project record data on a table
	selectedReportRecordData:[], // a state to keep track of the selected report record data on a table
}

const getters = {
  getCurrentProjectNavigation: state => state.currentProjectNavigation,
  getCurrentClusterNavigation: state => state.currentClusterNavigation,
  getNameCurrProjectNavigation: state => state.nameCurrProjectNavigation,
  getNameCurrClusterNavigation: state => state.nameCurrClusterNavigation,
  isMultiSelectedNavigation:state=>state.multiSelectedNavigation,
  isSingleSelectedNavigation:state=>state.singleSelectedNavigation,
  isLoadingClustProyNavigation:state=>state.loadingClustProyNavigation,
	getClusterSelectedObjNavigation:state=>state.clusterSelectedObjNavigation,
  isSelectedNavigation:state=>state.selectedNavigation,
  isAllowEditNavigation:state=>state.allowEditNavigation,
  isAllowEditClusterNavigation:state=>state.allowEditClusterNavigation,
	getCurrentProjectListNavigation:state=>state.currentProjectListNavigation,
	getSelectedClusterRecordData:state=>state.selectedClusterRecordData, // a get method to keep track of the selected cluster record data on a table
	getSelectedProjectRecordData:state=>state.selectedProjectRecordData,// a get method to keep track of the selected project record data on a table
	getSelectedReportRecordData:state=>state.selectedReportRecordData,// a get method to keep track of the selected report record data on a table


}

const actions = {
  setCurrentProjectNavigation({ commit }, newString){
    if(newString===''){
      commit('SET_CURRENT_NAME_PROJECT_NAVIGATION', '')
    }
    commit('SET_CURRENT_PROJECT_NAVIGATION', newString)
  },
  setCurrentClusterNavigation({ commit }, newString){
    if(newString===''){
      commit('SET_CURRENT_NAME_CLUSTER_NAVIGATION', '')
    }
    commit('SET_CURRENT_CLUSTER_NAVIGATION', newString)
  },
  resetCurrentClusterNavigation({ commit }){
    commit('SET_CURRENT_NAME_CLUSTER_NAVIGATION', '')
    commit('SET_CURRENT_CLUSTER_NAVIGATION', '')
    commit('SET_CURRENT_PROJECT_NAVIGATION', '')
    commit('SET_CURRENT_NAME_PROJECT_NAVIGATION', '')
  },
  setNameCurrClusterNavigation({ commit }, newString){
    commit('SET_CURRENT_NAME_CLUSTER_NAVIGATION', newString)
  },
  setNameCurrProjectNavigation({ commit }, newProjectName){
    commit('SET_CURRENT_NAME_PROJECT_NAVIGATION', newProjectName)
  },
  setSelectedNavigation({ commit }, selected){
    commit('SET_SELECTED_NAVIGATION', selected > 0)
    commit('SET_SINGLE_SELECTED_NAVIGATION', selected === 1)
    commit('SET_MULTI_SELECTED_NAVIGATION', selected > 1)
  },
  setLoadingClustProyNavigation({ commit }, newBool){
    commit('SET_LOADING_CLUST_PROY_NAVIGATION', newBool)
  },
	setClusterSelectedObjNavigation({ commit }, newObjt){
		try{
			commit('SET_PROJECT_OBJT_NAVIGATION', newObjt)
			commit('SET_PROJECT_LIST_NAVIGATION', newObjt.children)
		}catch{
			commit('SET_PROJECT_OBJT_NAVIGATION', newObjt)
		}
  },
  setAllowEditNavigation({ commit }, newBool){
    commit('SET_ALLOW_EDIT_PROY_NAVIGATION', newBool)
  },
  setAllowEditClusterNavigation({ commit }, newBool){
    commit('SET_ALLOW_EDIT_CLUSTER_NAVIGATION', newBool)
  },
	setSelectedClusterRecordData({ commit }, newObj){ // an action to set the selected cluster record data on a table
    commit('SET_SELECTED_CLUSTER_RECORD_DATA', newObj)
  },
	setSelectedProjectRecordData({ commit }, newObj){  // an action to set the selected project record data on a table
    commit('SET_SELECTED_PROJECT_RECORD_DATA', newObj)
  },
	setSelectedReportRecordData({ commit }, newObj){  // an action to set the selected report record data on a table
    commit('SET_SELECTED_REPORT_RECORD_DATA', newObj)
  },
}

const mutations = {
  SET_CURRENT_PROJECT_NAVIGATION: (state, newProject) => (state.currentProjectNavigation=newProject),
  SET_CURRENT_CLUSTER_NAVIGATION: (state, newCluster) => (state.currentClusterNavigation=newCluster),
  SET_CURRENT_NAME_PROJECT_NAVIGATION: (state, newProjectName) => (state.nameCurrProjectNavigation=newProjectName),
  SET_CURRENT_NAME_CLUSTER_NAVIGATION: (state, newString) => (state.nameCurrClusterNavigation=newString),
  SET_MULTI_SELECTED_NAVIGATION: (state, newBool) => (state.multiSelectedNavigation=newBool),
  SET_SINGLE_SELECTED_NAVIGATION: (state, newBool) => (state.singleSelectedNavigation=newBool),
  SET_SELECTED_NAVIGATION: (state, newBool) => (state.selectedNavigation=newBool),
  SET_LOADING_CLUST_PROY_NAVIGATION: (state, newBool) => (state.loadingClustProyNavigation=newBool),
  SET_ALLOW_EDIT_PROY_NAVIGATION: (state, newBool) => (state.allowEditNavigation=newBool),
	SET_PROJECT_LIST_NAVIGATION: (state, newList) => (state.currentProjectListNavigation=newList),
	SET_PROJECT_OBJT_NAVIGATION: (state, newObjt) => (state.clusterSelectedObjNavigation=newObjt),
  SET_ALLOW_EDIT_CLUSTER_NAVIGATION: (state, newBool) => (state.allowEditClusterNavigation=newBool),
	SET_SELECTED_CLUSTER_RECORD_DATA: (state, newObj)=>(state.selectedClusterRecordData=newObj), // a mutation to change the selected cluster record data on a table
	SET_SELECTED_PROJECT_RECORD_DATA: (state, newObj)=>(state.selectedProjectRecordData=newObj), // a mutation to change the selected project record data on a table
	SET_SELECTED_REPORT_RECORD_DATA: (state, newObj)=>(state.selectedReportRecordData=newObj), // a mutation to change the selected report record data on a table
}

export default {
  state,
  getters,
  actions,
  mutations
}
